<template>
  <div class="mediation-type-container animated fadeInRight">
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>调解纠纷类型管理</span>
        <el-button type="primary" size="small" @click="_openAdd">新增类型</el-button>
      </div>
      <el-row :gutter="20" style="margin-bottom:15px">
        <el-col :span="6">
          <el-input v-model="conditions.typeName" placeholder="按类型名称搜索" clearable @keyup.enter.native="_loadList" />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_loadList">查询</el-button>
          <el-button @click="_resetConditions">重置</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" border v-loading="loading" style="width:100%">
        <el-table-column prop="typeName" label="类型名称" align="center" />
        <el-table-column label="关联调解员" align="center">
          <template slot-scope="scope">
            <el-tag
              v-for="(m, i) in (scope.row.mediators || [])"
              :key="i"
              type="info"
              style="margin-right:6px;margin-bottom:4px"
            >{{ m.staffName || m.staffId }}</el-tag>
            <span v-if="!scope.row.mediators || scope.row.mediators.length === 0" style="color:#999">未设置</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="180" />
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="_openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="_doDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑 弹窗 -->
    <el-dialog :title="editDialog.isEdit ? '编辑纠纷类型' : '新增纠纷类型'" :visible.sync="editDialog.visible" width="1200px" :close-on-click-modal="false">
      <el-form :model="editDialog" label-width="100px">
        <el-form-item label="类型名称" required>
          <el-input v-model="editDialog.typeName" placeholder="请填写类型名称" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="调解员">
          <select-staffs ref="selectStaffs" @selectStaffs="handleStaffSelected" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="_submitEdit" :loading="editDialog.submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listDisputeTypes,
  saveDisputeType,
  updateDisputeType,
  deleteDisputeType
} from '@/api/oa/mediationApi'
import SelectStaffs from '@/components/staff/selectStaffsDiv'

export default {
  name: 'MediationTypeList',
  components: {
    SelectStaffs
  },
  data() {
    return {
      loading: false,
      tableData: [],
      conditions: {
        typeName: ''
      },
      editDialog: {
        visible: false,
        isEdit: false,
        typeId: '',
        typeName: '',
        mediators: [],
        submitting: false
      }
    }
  },
  mounted() {
    this._loadList()
  },
  methods: {
    _loadList() {
      this.loading = true
      listDisputeTypes(this.conditions).then(res => {
        const d = res.data || res || {}
        this.tableData = d.disputeTypes || []
      }).catch(err => {
        this.$message.error(err || '加载失败')
        this.tableData = []
      }).finally(() => {
        this.loading = false
      })
    },
    _resetConditions() {
      this.conditions.typeName = ''
      this._loadList()
    },
    _openAdd() {
      this.editDialog.isEdit = false
      this.editDialog.typeId = ''
      this.editDialog.typeName = ''
      this.editDialog.mediators = []
      this.editDialog.visible = true
      this.$nextTick(() => {
        this.$refs.selectStaffs.setStaffs([])
      })
    },
    _openEdit(row) {
      this.editDialog.isEdit = true
      this.editDialog.typeId = row.typeId
      this.editDialog.typeName = row.typeName
      this.editDialog.mediators = row.mediators || []
      this.editDialog.visible = true
      // 回显已选调解员（组件内部使用 userId/name 结构）
      this.$nextTick(() => {
        this.$refs.selectStaffs.setStaffs(
          (row.mediators || []).map(m => ({ userId: m.staffId, name: m.staffName }))
        )
      })
    },
    handleStaffSelected() {
      // 员工选择变化时无需额外处理，提交时统一读取
    },
    _submitEdit() {
      if (!this.editDialog.typeName) {
        this.$message.error('请填写类型名称')
        return
      }
      // 从组件读取已选员工，转换为后端需要的 mediators 结构
      const selected = (this.$refs.selectStaffs && this.$refs.selectStaffs.getSelectedStaffs()) || []
      const mediators = selected.map(s => ({
        staffId: s.userId,
        staffName: s.name
      }))
      this.editDialog.submitting = true
      const fn = this.editDialog.isEdit ? updateDisputeType : saveDisputeType
      const params = {
        typeId: this.editDialog.typeId,
        typeName: this.editDialog.typeName,
        mediators: mediators
      }
      fn(params).then(() => {
        this.$message.success(this.editDialog.isEdit ? '更新成功' : '保存成功')
        this.editDialog.visible = false
        this._loadList()
      }).catch(err => {
        this.$message.error(err || '操作失败')
      }).finally(() => {
        this.editDialog.submitting = false
      })
    },
    _doDelete(row) {
      this.$confirm('确认删除该纠纷类型？已使用该类型的案件不受影响。', '删除确认', {
        type: 'warning'
      }).then(() => {
        deleteDisputeType({ typeId: row.typeId }).then(() => {
          this.$message.success('删除成功')
          this._loadList()
        }).catch(err => {
          this.$message.error(err || '删除失败')
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.mediation-type-container {
  padding: 20px;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
